<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" @closed="onClosed">
      <h3 class="header fs18 pt20 pb10 pl15 pr15 flex-center flex jcsb">
        <span>我要做日间手术</span>
        <v-icon-close @click.native="close"></v-icon-close>
      </h3>
      <div class="pl15 pr15 pb15 pt15 color_666" v-html="p1.content">
        若您未在我院就诊过，请先挂号就诊，让医生为您评估是否适合安排日间手术。
      </div>

      <div class="pl15 pr15 pt10 pb10">
        <van-button type="info" block round @click="onClick('book')">预约挂号</van-button>
      </div>

      <div style="border-bottom: 1px dashed #cccccc" class="ml15 mr15 mt10"></div>

      <div class="pl15 pr15 pb15 pt15 color_666" v-html="p2.content">
        若您需要其他帮助，如查询失败、日间手术咨询等，您可以选择以下服务
      </div>

      <div class="footer flex pl15 pr15 pb15 pt15">
        <!--        <van-button type="info" round plain hairline style="width: 45%" @click="onClick('call')">联系客服</van-button>-->
        <van-button type="info" block plain round @click="onClick('consult')">在线咨询医生</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import VIconClose from "@/plugins/v-icon-close";
import {systemService} from "@/services/system";

export default {
  name: "yygh-confirm-information",
  components: {VIconClose},
  data() {
    return {
      p1: {},
      p2: {},
      type: '',
      showTag: false
    }
  },
  async created() {
    // 日间手术挂号描述
    // 日间手术咨询描述
    this.p1 = await systemService.sysNewsDetail('日间手术挂号描述') || {}
    this.p2 = await systemService.sysNewsDetail('日间手术咨询描述') || {}
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    }
  },
}
</script>

<style scoped>
.footer {
  justify-content: space-between;
}

p + p {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/ds-todo.vue